import { render, staticRenderFns } from "./ProjectsListFilters.vue?vue&type=template&id=4b036b00&"
import script from "./ProjectsListFilters.vue?vue&type=script&lang=js&"
export * from "./ProjectsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports